import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, utils, Loader, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import * as ciselnikActions from "../actions/ciselnikActions";
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu pobočky.
 */
class PobockaForm extends Component<WithTranslation> {

    static formName = 'PobockaForm';

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchPobockyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchDopravciIfNeeded());
    };

    render() {
        const {onClose, submitting, handleSubmit, pobockyList, dopravciList, initialValues, t} = this.props;
        const pobockaId = initialValues && initialValues.id;
        return pobockyList.fetched && dopravciList.fetched ? <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.ObjectSuggest
                    label={t('confirming_branch')}
                    name="pobockaPotvrzuje"
                    dropdown={true}
                    removable={false}
                    items={pobockyList.rows.filter(p => !pobockaId || p.id !== pobockaId)}
                    getItemValue={(item) => item ? item.nazevPobocka : ""}
                    renderSuggestion={item => item ? item.nazevPobocka : ""}
                />
                <ff.Number int label={t('labels.number')} name="cisloPobocka" required disabled={submitting}/>
                <ff.String label={t('labels.name')} name="nazevPobocka" required disabled={submitting}/>
                <ff.String label={t('street')} name="ulice" disabled={submitting}/>
                <ff.String label={t('zip')} name="psc" disabled={submitting}/>
                <ff.String label={t('city')} name="obec" disabled={submitting}/>
                <ff.String label={t('phone')} name="telefon" disabled={submitting}/>
                <ff.String label={t('email')} name="email" disabled={submitting}/>
                <ff.String label={t('labels.www')} name="www" disabled={submitting}/>
                <ff.String label={t('zip_filter')} name="filtrPsc" disabled={submitting}/>
                <ff.String label={t('ip_filter')} name="filtrIpAdresa" disabled={submitting}/>
                <ff.String label={t('folder_upload')} name="slozkaUpload" disabled={submitting}/>
                <ff.Number int label={t('order.production_time_minutes')} name="casZhotoveniZakazky" disabled={submitting}/>
                <ff.ObjectSuggest
                    label={t('carrier')}
                    name="dopravce"
                    dropdown={true}
                    removable={false}
                    items={dopravciList.rows}
                    getItemValue={(item) => item ? item.dopravce : ""}
                    renderSuggestion={item => item ? item.dopravce : ""}
                />
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
                <CustomCheckboxField label={t('dispensing_place')} name="vydejniMisto" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form> : <Loader/>
    }
}

function mapStateToProps(state) {
    return {
        pobockyList: utils.storeFromArea(state, ciselnikActions.POBOCKY_LIST_AREA),
        dopravciList: utils.storeFromArea(state, ciselnikActions.DOPRAVCI_LIST_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: PobockaForm.formName,
})(PobockaForm)));
